<template>
  <div class="drop--item--card__container">
    <div :class="{'width--longer': timeVisible}" class="drop--item--card__date">
      <span v-if="timeVisible" class="drop--item--card__date--title">
        {{drop.departure | timeToReadableTz($i18n.locale)}} - {{drop.arrival | timeToReadableTz($i18n.locale)}}
      </span>
      <template v-if="!timeVisible">
        <span :class="[timeVisible ? 'drop--item--card__date--subtitle' : 'drop--item--card__date--title onlyTitle']">{{drop.departure | dateToReadable($i18n.locale)}}</span>
        <span :class="[timeVisible ? 'drop--item--card__date--subtitle' : 'drop--item--card__date--title onlyTitle']">{{drop.arrival | dateToReadable($i18n.locale)}}</span>
      </template>
      <span v-else>
        <span class="drop--item--card__date--subtitle">
        {{drop.departure | dateToReadableTz($i18n.locale)}} - {{drop.arrival | dateToReadableTz($i18n.locale)}}
      </span>
      </span>
    </div>
    <div class="drop--item--card__organization">
      <span class="drop--item--card__organization--title">
       {{ computeDestinationOrganizationName }}
      </span>
      <span class="drop--item--card__organization--subtitle">
        <span>{{splitAddress.city}}</span>
        <span class="dotted--before--text">{{splitAddress.countryCode}}</span>
      </span>
    </div>
    <div class="drop--item--card__info">
      <DropCardInfo :icon="'fas fa-box'" :text="computeWeight" />
      <DropCardInfo :icon="'fas fa-arrows-alt'" :text="computeVolume" />
    </div>
    <div :class="{'width--35': timeVisible}" class="drop--item--card__labels">
      <div :style="{backgroundColor: dropPalletization.color}" v-show="dropPalletization" class="drop--item--card--label__item width--longer">
        <span>{{ dropPalletization.value }}</span>
      </div>
      <!-- <div class="drop--item--card--label__item">
        <span>Traza Z</span>
      </div> -->
      <div v-show="(drop.status != null && drop.status.length > 0)" class="drop--item--card--label__item width--longer">
        <span>
          {{$t('drops.'+drop.status)}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapActions, mapGetters } from 'vuex'
// import { dropService } from '@/_services'
import DropCardInfo from '@/components/drops/DropCardInfo.vue'
export default {
  name: 'ShipmentsDropItemCard',
  components: {
    DropCardInfo
  },
  props: {
    drop: { type: Object, default: () => { return { arrival: 0, departure: 0 } } }
  },
  methods: {},
  computed: {
    timeVisible: function () {
      return this.drop.shipmentID !== 'none'
    },
    splitAddress: function () {
      if (typeof this.drop.destination.address === 'object') {
        return this.drop.destination.address
      }
      let addressArray = this.drop.destination.address.split(',')
      let address = { city: addressArray[0], countryCode: addressArray[1] }
      return address
    },
    computeWeight: function () {
      // if (this.drop.weight >= 1000) {
      //   return (this.drop.weight / 1000).toFixed(0) + ' t'
      // }
      return this.$options.filters.roundValueWeight(this.drop.weight, 0) + ' kg'
    },
    computeVolume: function () {
      return this.$options.filters.roundValue(this.drop.volume, 1) + ' m³'
    },
    computeDestinationOrganizationName: function () {
      return this.drop.destination.orgName != null ? this.drop.destination.orgName : this.drop.destination.organization.name
    },
    dropPalletization () {
      let result = ''
      if (this.drop.consolidation === undefined) {
        if (this.drop.patelization != null) {
          result = this.$t('drops.' + this.drop.patelization)
        } else if (this.drop.unitsCount != null) {
          const customBoxIndex = this.drop.unitsCount.findIndex(({ type }) => type === 'CustomBox')
          const palletIndex = this.drop.unitsCount.findIndex(({ type }) => type === 'EurPallet' || type === 'CustomPallet')
          if (customBoxIndex >= 0 && palletIndex >= 0) {
            return { value: this.$t('drops.PartiallyPalletized'), color: '#ffb801' }
          } else if (customBoxIndex < 0 && palletIndex >= 0) {
            return { value: this.$t('drops.FullyPalletized'), color: '#50E898' }
          } else {
            return { value: this.$t('drops.NotPalletized'), color: '#767676' }
          }
        } else {
          return false
        }
      } else {
        let palletizedColor = '#767676'
        if (this.drop.consolidation === 'PartiallyPalletized') {
          palletizedColor = '#ffb801'
        } else if (this.drop.consolidation === 'FullyPalletized') {
          palletizedColor = '#50E898'
        }
        result = { value: this.$t('drops.' + this.drop.consolidation), color: palletizedColor }
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
